module.exports = __webpack_public_path__ + "static/group-bg-5-18d91d309cd913278619f39795475183.jpg";